module.exports = __webpack_public_path__ + "static/images/panelBuilder/swap-horizontal.svg";